import { formatName } from "@api";
import type { ICandidate } from "@bbj-types/candidate";
import type { IUser } from "@bbj-types/user";

export const getMessageAuthor = (
  candidate: Pick<ICandidate, "firstName" | "lastName"> | undefined,
  createdBy: Pick<IUser, "firstName" | "lastName"> | undefined,
  direction: "received" | "sent"
) => {
  let author = "";

  if (direction === "received" && candidate) {
    author = [candidate.firstName, candidate.lastName].filter(Boolean).join(" ");
  }
  if (direction === "sent" && createdBy) {
    author = formatName(createdBy);
  }

  return author !== "" ? `(${author})` : author;
};
